<template>
    <Modal
        :showModal="showModal"
        title="Aviso"
        @closeModal="onCloseModal"
    >
        <p class="text-[16px] leading-6">Para acessar o catalogo de prêmios é necessário a atualização de email cadastral, por favor entre em contato com o SAC</p>
    </Modal>
</template>

<script>
import Icon from '@/Components/UI/Icons/Icon.vue';
import Button from '@/Components/Button.vue';
import Heading from '@/Components/UI/Texts/Heading.vue';
import Modal from "@/Components/UI/Modals/Modal.vue";

export default {
    components:{
        Icon,
        Button,
        Heading,
        Modal,
    },

    props:{
        showModal: Boolean,
        closeModal: Function
    },
    data(){
        return{
        }
    },
    methods: {
        onCloseModal() {
            this.$emit("closeModal");
        },
        closeChangeModal() {
            this.onCloseModal();
        },
    }
}
</script>
<style scoped></style>